const ERROR_TYPES = {
    EMAIL_FORMAT_ERROR: 'email_format',
    SERVER_ERROR: 'server_error',
};

module.exports = {
    ERROR_TYPES,
};
